<style scoped>
@import "./index.css";
</style>

<template>
    <div id="login">
        <div class="login-header"></div>
        <div class="login-content-wrap">
          <div class="login-content">
              <Row type="flex" justify="center">
                  <Col :xs="24">
                      <div class="header-logo">
                          <h3>注册账户</h3>
                      </div>
                      <Alert show-icon>欢迎使用瀚土智能管理系统</Alert>
                      <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule">
                          <FormItem prop="phone">
                              <Input clearable placeholder="请输入手机号" :maxlength="11" icon="ios-person" size="large" type="text" v-model="accountLogin.phone"></Input>
                          </FormItem>
                          <FormItem prop="verify_code" class="yzm">
                              <Input clearable placeholder="请输入验证码" :maxlength="4" size="large" type="text" v-model="accountLogin.verify_code"></Input>
                              <span :class="['yzm-btn',accountLogin.is_code === false ? 'active' : '']" @click="getCode">{{accountLogin.code_name}}</span>
                          </FormItem>
                          <FormItem prop="password">
                              <Input clearable placeholder="请输入密码" icon="ios-unlock" size="large" type="password" v-model="accountLogin.password"></Input>
                          </FormItem>
                          <FormItem class="mb5">
                              <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                                  <span>{{!accountLogin.btnLoading ? '注册' : '注册中...'}}</span>
                              </Button>
                          </FormItem>
                          <FormItem class="tf-text-right">
                              我有账户? <a href="javascript:;" @click="$func.jumps('login')">立即登录</a>
                          </FormItem>
                      </Form>
                  </Col>
              </Row>
          </div>
        </div>
        <div class="login-footer">
            © 1999-2019 瀚土智能 All rights reserved.
        </div>
    </div>
</template>

<script>
export default {
    name: "regist",
    beforeCreate() {
        //设置背景色
        document.querySelector("body").setAttribute("style", "background:#fbfbfb");
    },
    beforeDestroy() {
        //去除背景色
        document.querySelector("body").setAttribute("style", "");
    },
    created() {
        const that = this;
    },
    data() {
        return {
          // +---------------
          // | 输入框数据
          // +---------------
          accountLogin: {
            phone: "",
            password: "",
            verify_code:'',
            btnLoading: false,

            //验证码
            is_code:false,
            code_name:"获取验证码",
          },

          // +---------------
          // | 验证规则
          // +---------------
          accountLoginRule: {
            //账号登录
            phone: [
                {required: true, message: "请输入手机号", trigger: "blur" },
                {
                    message: "请输入正确的手机号",
                    trigger: "change",
                    validator:this.validatePhone
                }
            ],
            verify_code: [
              {required: true, message: "请填写验证码", trigger: "blur"},
              {pattern: /^\d{4}$/, message: "请输入4位数字验证码", trigger: "blur"},
            ],
            password: [
              {required: true, message: "请设置密码", trigger: "blur" },
              {pattern: /^[a-zA-Z0-9]{6,16}$/, message: "请输入6-16位的字母、数字", trigger: "blur" }
            ]
          }
        }
    },
    methods: {
        //验证手机
        validatePhone(rule, value, callback){
            const that = this;
            if (value === '') {
                callback(new Error(rule.message));
            } else {
                if (!that.$func.checkphone(that.accountLogin.phone)) {
                    callback(new Error(rule.message));
                }else{
                    that.accountLogin.is_code = true;
                }
                callback();
            }
        },
        //获取验证码
        getCode:function()
        {
          const that = this;
          //判断
          if(that.accountLogin.is_code)
          {
              if(that.$func.checkphone(that.accountLogin.phone))
              {
                  //请求接口
                  that.$func.ajax('sendRegisterCode',
                  {
                      phone: that.accountLogin.phone
                  },
                  function(r) {
                      if(!r.statusCode){
                          that.$func.msg(r.message,'error');
                      }else{
                          that.accountLogin.is_code = false;
                          let _time  = 60;
                          //倒计时 并且 不可点击
                          let dsq = setInterval(function(){
                              _time--;
                              if(_time > 0){
                                  that.accountLogin.code_name = _time+"秒";
                              }else if(_time == 0){
                                  clearInterval(dsq);
                                  that.accountLogin.is_code = true;
                                  that.accountLogin.code_name = "重新获取验证码";
                              }
                          },1000)
                      }
                  })
              }else{
                  that.$func.msg('请输入正确的手机号!')
              }
          }
        },
        // +---------------
        // | 提交表单
        // +---------------
        handleSubmit(name) {
          const that = this;
          //验证表单
          that.$refs[name].validate(valid => {
            if (valid)
            {
                //按钮状态关闭
                that[name].btnLoading = false;

                //请求接口
                that.$func.ajax('doRegister',
                {
                    phone: that.accountLogin.phone,
                    loginPwd: that.accountLogin.password,
                    phoneCode : that.accountLogin.verify_code,
                    // openId : that.openId,
                    // openData : that.openData,
                    // accessToken : that.accessToken,
                    // regType : that.regType //1-微信 2-qq 3-微博 不填写代表不绑定
                },
                function(r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        //自动登录
                        if(that.regType == 1){ //微信
                            that.$func.msg('绑定成功!');
                            that.doLoginWx();
                        }else if(that.regType == 2){ //qq
                            that.$func.msg('绑定成功!');
                            that.doLoginQq();
                        }else if(that.regType == 3){ //微博
                            that.$func.msg('绑定成功!');
                            that.doLoginWb();
                        }else{ //普通登录
                            that.$func.msg('注册成功!');
                            that.doLoginPwd();
                        }
                        //重置
                        that.$refs[name].resetFields();
                        //跳转
                        // that.$func.dsqOut(function() {
                        //     that.$router.push({
                        //         name: "login"
                        //     });
                        // },2);
                    }
                })
            }
          });
        },
        //普通登录
        doLoginPwd(){
            let that = this;
            that.$func.ajax('doLoginPwd',
            {
                phone : that.accountLogin.phone,
                loginPwd : that.accountLogin.password,
            },function(r){
                if(!r.statusCode){
                    that.$func.msg(r.message,'error');
                }else{
                    //存储登录数据
                    that.$func.data.set("userInfo", r.type);
                    //跳转
                    that.$func.dsqOut(function() {
                        that.$router.push({
                            name: "index"
                        });
                    },1.5);
                }
            })
        },
        //微信登录
        doLoginWx(){
            let that = this;
            // func.api(router.doLoginWx,{
            //     openId : that.openId,
            //     accessToken : that.accessToken,
            //     pushId : that.pushId,
            //     force : 1
            // },function(r){
            //     if(!r.statusCode){
            //         func.msg(r.message);
            //     }else{
            //         // func.msg("登录成功！");
            //         //存储登录数据
            //         $api.setStorage('userInfo',r.type);
            //         func.openWin('select_type','regist/select_type.html');
            //         setTimeout(function(){
            //             api.closeWin()
            //         },2000)
            //     }
            // })
        },
        //qq登录
        doLoginQq(){
            let that = this;
            // func.api(router.doLoginQq,{
            //     openId : that.openId,
            //     accessToken : that.accessToken,
            //     pushId : that.pushId,
            //     force : 1
            // },function(r){
            //     if(!r.statusCode){
            //         func.msg(r.message);
            //     }else{
            //         // func.msg("登录成功！");
            //         //存储登录数据
            //         $api.setStorage('userInfo',r.type);
            //         func.openWin('select_type','regist/select_type.html');
            //         setTimeout(function(){
            //             api.closeWin()
            //         },2000)
            //     }
            // })
        },
        //微博登录
        doLoginWb(){
            let that = this;
            // func.api(router.doLoginWb,{
            //     openId : that.openId,
            //     accessToken : that.accessToken,
            //     pushId : that.pushId,
            //     force : 1
            // },function(r){
            //     if(!r.statusCode){
            //         func.msg(r.message);
            //     }else{
            //         // func.msg("登录成功！");
            //         //存储登录数据
            //         $api.setStorage('userInfo',r.type);
            //         func.openWin('select_type','regist/select_type.html');
            //         setTimeout(function(){
            //             api.closeWin()
            //         },2000)
            //     }
            // })
        }
    }
};
</script>
